import services from './../../../services/service'; // Service Class

let service = new services();
// import ProductForm from '../../../components/product/ProductForm.vue'
// import ProductItemForm from '../../../components/product/ProductItemForm.vue'
// import ProductCartActions from '../../../components/product/ProductCartActions.vue'

//
import setts from './../../../resources/setts'; //settings
//let service = new services();

import {
  ADD_TO_CART,
  REMOVE_FROM_CART
} from '../../../store/mutation-types'
export default {
    name: 'Cart',
    props: ['userprop'],
    mixins: [setts],
    data () {
        return {
          loading:false,
          user: {},
          group_products:{},
          item_product:{},
          checked_out: [],
          processed_checkout_orders: [],
          sorted_cart: [],
          orders: [],
          cart: this.$store.state.cart,
          img_product_url: service.imageProductsURL,
          coupon_code:[],
          product_delivery_fee: "",
          sellpoint_delivery_fee: "",
          payment_option: "",
          total_order_amt: 0.0,
          total_delivery_fee: 0.0,
          processed_groups:0,
          process_count:0,
          loggedIn:false,
          loading: true,
          buy_now_order:false,
          share_cart_option:false,
          part_payments_request_option:false,
          has_part_payments_request:0,
          data_processing_message:"",
          action_loading:false,

          //force re-render keys..use for now..recode components for better rerendering
          shipping_fee_key:0,
          total_orders_key: 0,
          shipping_fee_key_options:0,
          order_delivery_main_location:{},
          states:[],
          cities:[],
          componentDeliveryLocationsKey:0,
          componentProductDeliveryLocationsKey:0,
          disable_btn_01: false,
          coupon_entry: '',
          coupon_entry_error:'',
          couponsComponentKey:0,
        }
      },
    components: {
       
      },
    computed: {
        // a computed getter
        // totalDeliveryFee: function () {
        //     this.sorted_cart.forEach(function(element) {
        //         console.log(element['delivery_option_fee'])
        //         /////this.total_delivery_fee += element['delivery_option_fee']
        //         return element['delivery_option_fee']
        //     });
        // }
    },
    methods:{
        setComponent(attr1,attr2){},

        showDropdown(id){
            document.getElementById(id).style = "display:block";
            var stl = document.getElementById(id).style;
            if(stl == "display:block"){
                document.getElementById(id).style = "display:none";
            }else{
                document.getElementById(id).style = "display:block";
            }
        },

        numFormat(str){
            return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        },

        forceRerender(){
            this.shipping_fee_key += 1;
            this.total_orders_key += 1;
            this.shipping_fee_key_options += 1;
        },

        toggleSingleDisplay(attr,id){
            if(attr == true){
                document.getElementById(id).style = "display:block";
            }else{
                document.getElementById(id).style = "display:none";
            }
            // this.sorted_cart[i][1][i2].product_item_id++;
            // this.componentProductDeliveryLocationsKey++
        },

        toggleDoubleMultiDisplay(show_arr,hide_arr){
            // document.getElementById(show).style= "display:block";
            // document.getElementById(hide).style= "display:none";
            
            //show
            for(let show of show_arr){
                document.getElementById(show).style = "display:block";
            }

            //hide
            for(let hide of hide_arr){
                document.getElementById(hide).style = "display:none";
            }
        },

        toggleProductDelivery(attr1,i,product_index){
            if(attr1 == 'item-delivery-options'){
                this.sorted_cart[i][1][product_index].display_delivery_details = true;
            }
            if(attr1 == 'hide-item-delivery-options'){
                this.sorted_cart[i][1][product_index].display_delivery_details = false;
            }
        },

        toggleSellpointDelivery(attr1,i){
            if(attr1 == 'group-delivery-options'){
                this.sorted_cart[i].display_delivery_details++;
            }
            if(attr1 == 'hide-group-delivery-options'){
                this.sorted_cart[i].display_delivery_details = false;
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        checkOrderQuantity(group_index,item_index,item_qty,qty){
            if(Number(qty) > item_qty){
                this.sorted_cart[group_index][1][item_index].quantity_check_pass = false;
                document.getElementById("qty_c"+item_index).innerHTML = "The quantity you entered is above Item Quantity";
                document.getElementById("qty_t"+item_index).style= "display:none"; //showing totals
                return false; //for when called
            }else{
                this.sorted_cart[group_index][1][item_index].quantity_check_pass = true;
                document.getElementById("qty_c"+item_index).innerHTML = "";
                // this.sorted_cart[group_index][1][item_index].check_order_quantity = "";
                document.getElementById("qty_t"+item_index).style= "display:block"; //showing totals
                return true; //for when called
            }
        },

        checkDiscountsByQuantity(group_index,item_index,item_qty,qty){ //item_qty-quantity of the product item //qty-quantity ordered
            //refresh
            this.sorted_cart[group_index][1][item_index].product_item_total_discount = 0;
            if(this.sorted_cart[group_index][1][item_index].product_item_actual_price != 0){
                this.sorted_cart[group_index][1][item_index].product_item_price = this.sorted_cart[group_index][1][item_index].product_item_actual_price;
            }
            //.//refresh
            let total_discount = 0; let calc_discount = 0; let product_item_discount_price = 0;
            // get quantities that match
            //then recalculate coupons ...//check for both group and items calculations

            //check in item
            for(let dc of this.sorted_cart[group_index][1][item_index].product_item_discounts) { //item
                if((dc['discount_status_id'] == 5)){ //active - not expired
                    if(dc['discount_coupon'] == 'D'){
                        if(Number(Number(qty) >= dc['discount_min_quantity'])){ //discounts
                            total_discount += Number(Number(dc['discount_percentage']));
                        }
                    }
                    if(dc['discount_coupon'] == 'C'){ //coupons
                        if(Number(Number(qty) <= dc['discount_min_quantity'])){ //less
                            //check if added //so u can deduct //for proper sync
                            if(dc['added']){
                                this.set_coupons(group_index,item_index,dc,dc['discount_percentage']);
                            }
                        }
                    }
                }
            }
            
            if(total_discount != 0){
                this.sorted_cart[group_index][1][item_index].product_item_actual_price = this.sorted_cart[group_index][1][item_index].product_item_price; //store first
                
                //calc product_actual_price and product_item_discount_price
                calc_discount = ((total_discount/100) * this.sorted_cart[group_index][1][item_index].product_item_actual_price);
                product_item_discount_price = (this.sorted_cart[group_index][1][item_index].product_item_price - calc_discount);
                this.sorted_cart[group_index][1][item_index].product_item_total_discount = total_discount;
                this.sorted_cart[group_index][1][item_index].product_item_price = product_item_discount_price;
                // $total_product_item_discounted += 1;
            }
        },

        removeFromCart (item_id,group_index,item) {
            this.removeFromSortedCart(group_index,item);
            this.$store.commit(REMOVE_FROM_CART, item_id);

            //new
            this.prepCart(); //refresh hack
            // window.top.location.reload(false)
        },

        removeFromSortedCart(group_index,item){
            const index = this.sorted_cart[group_index][1].findIndex(p => p._id === item._id) //best removal
            this.sorted_cart[group_index][1].splice(index, 1);
        },

       
        prepCart(){
            this.activate_processing(); // refresh
            //sort min cart into sorted carts...//BEFORE
            let sorted_cart = Object.values(this.cart.reduce((result, obj) => {
                // (result[obj.product_business] || (result[obj.product_business] = [])).push(obj);
                (result[obj.product_business_sort] || (result[obj.product_business_sort] = [])).push(obj);
                return result;
            }, {}));
            //../sort min cart into sorted carts

            let count = 0; let buy_now_count = 0; //ini
            let sorted_cart_array = [];
            let pre_sort_index = 0;
            sorted_cart.forEach(function(element) {
                let pre_sort = [];

                //some watchers
                pre_sort.can_show = true; //can be turned on/off
                pre_sort.products_with_delivery_details_count = 0;
                pre_sort.products_without_delivery_details_count = 0;
                pre_sort.products_with_delivery_details_checked = [];
                pre_sort.products_without_delivery_details_checked = [];
                
                //loop through cart items to keep default settings
                element.forEach(function(item) {
                    //some settings
                    item.can_show = true; //can be turned on/off
                    item.can_remove = true; //help in switching delete and not delete
                    item.display_delivery_details = false;
                    item.actual_product_item_price = item.product_item_price; //save the state of this item price
                    item.item_order_coupons_discounts = []; //setting array to fetch orderde coupons of this item
                    item.total_item_order_coupons_amount = 0;
                    // console.log(item.item_order_coupons_discounts);
                    item.has_delivery = false; //reset
                    if(item.product_checked){
                        item.product_checked = false;
                    }
                    //check products with specific delivery details
                    service.getProductDeliveryOptions(this, item.product_main_id).then(response => { //recheck
                        if(response.body.status == 200) {
                            item.has_delivery = true;
                            item.delivery_option = 0;
                            pre_sort.products_with_delivery_details_count += 1;
                        }else{
                            pre_sort.products_without_delivery_details_count += 1;
                        }
                    }).catch((err) => {pre_sort.products_without_delivery_details_count += 1;})
                    //check part payment option
                    if(item.product_order_part_payments_request == 1){
                        this.has_part_payments_request++; //for switching views
                    }
                    //--check if can show
                    if(this.part_payments_request_option && (item.product_order_part_payments_request == 0)){
                        item.can_show = false;
                    }
                    //--check if can show
                },this);
                pre_sort.display_delivery_details = 0;
                pre_sort.business_name = element[0].product_business_name; //main business name
                pre_sort[0] = element[0].product_business;  //business username
                //agent check
                pre_sort.is_from_agent = 0;
                if((element[0].product_is_from_agent) && (element[0].product_is_from_agent == 1)){
                    pre_sort.is_from_agent = element[0].product_is_from_agent; //main business name
                    pre_sort.business_agent_username = element[0].product_business_agent_username;  //business username
                    pre_sort.business_agent_name = element[0].product_business_agent_name; //main business name
                }
                //part-payments//coming-from single product-order-cta-type-3//donate..
                //--if a particular product order is requested for 
                pre_sort.part_payments_request = 0;
                if((element[0].product_order_part_payments_request) && (element[0].product_order_part_payments_request == 1)){
                    pre_sort.part_payments_request = element[0].product_order_part_payments_request; 
                }
                //--check if can show
                if(this.part_payments_request_option && (pre_sort.part_payments_request == 0)){
                    pre_sort.can_show = false;
                }
                //../part-payments
                pre_sort[1] = element; //the cart items
                pre_sort.items_in_checkout = 0; // assign true if products are assigned to cart
                pre_sort.total_order_amt = 0.0; //assign shop total orders
                pre_sort.show_delivery_option = 0; //assign
                pre_sort.delivery_option_fee = 0.0; //asign delivery fee
                pre_sort.total_delivery_charge = 0.0; //including products individual delivery
                pre_sort.delivery_states = []; //states in delivery states
                pre_sort.selected_delivery_state_locations = [];
                pre_sort.total_order_coupons_amount = 0.0; // for all selectedcoupons total amount
                pre_sort.order_coupons_discounts = []; // for all selectedcoupons
                pre_sort[4] = []; //some settings for getBusinessDiscountsAndCoupons

                //promises hub
                let promises = [];
                for (let i = 0; i < 5; ++i) {
                    if(i == 1){
                        //check for available coupons
                        promises.push(
                            service.getBusinessDiscountsAndCoupons(this, element[0].product_business).then(response => { //recheck
                                if(response.body.status == 200) {
                                     pre_sort[4] = response.body.data;
                                }
                            }).catch((err) => {})
                        )
                    }
                    
                    if(i == 2){
                        //prep delivery options
                        promises.push(
                            service.getBusinessDeliveryOptions(this, element[0].product_business).then(response => { //recheck
                                if(response.body.status == 200){
                                    let delivery_options = response.body.data;
                                    pre_sort.delivery_states = response.body.data_states;
                                    
                                    //initially
                                    // pre_sort[2] = response.body.data;
                                    //../initially

                                    //updated
                                    //check if this business sorted cart has only one item and if that item has product id set
                                    //check element length
                                    // if(element.length == 1){
                                    let last_or_only_item_in_array = (element[element.length -1]);
                                    if(last_or_only_item_in_array){
                                        delivery_options.forEach(function(item) {
                                            let fees =  item.business_products_delivery_fees;
                                            //check first if has products delivery fee
                                            if(fees.length != 0){
                                                //loop through the product_delivery fees of each one
                                                fees.forEach(function(fee) {
                                                    //check if element has set product delivery fee
                                                    // if(element[0].product_main_id == fee.product_delivery_product){
                                                    if(last_or_only_item_in_array.product_main_id == fee.product_delivery_product){
                                                        //attach has_product_delivery_fee
                                                        item.has_product_delivery_fee = true;
                                                        item.business_product_delivery_fee = fee.product_delivery_fee;
                                                    }
                                                },this)
                                            }else{
                                                pre_sort[2] = delivery_options;
                                                this.deactivate_processing();
                                            }
                                        },this)
                                        //assign after loop
                                        // pre_sort[2] = delivery_options;
                                    }else{
                                        // pre_sort[2] = delivery_options;
                                        this.deactivate_processing(); 
                                    }
                                    //assign after check
                                    pre_sort[2] = delivery_options;
                                    if(pre_sort.delivery_states.length == 1){ 
                                        pre_sort.selected_delivery_state_locations = delivery_options;
                                    }
                                    //--./updated

                                    //also updated ... business_shipping_calculation_method ../handle undefined errors later
                                    pre_sort.business_shipping_calculation_method = response.body.data_business_set_shipping_fee_status;
                                    this.deactivate_processing();
                                }else{
                                    pre_sort.delivery_option = "Free Delivery" //set by default
                                    pre_sort.delivery_general_set_option = {}; //set by default
                                    this.deactivate_processing();
                                }

                                //more new
                                pre_sort.business_min_delivery_fee = response.body.data_min_delivery_fee;
                                pre_sort.business_max_delivery_fee = response.body.data_max_delivery_fee;

                                
                                // check pay on delivery
                                // service.checkBusinessPayOnDelivery(this, element[0].product_business).then(response => {
                                //     if(response.body.status == 200) {
                                //         pre_sort[3] = response.body.data;
                                //         sorted_cart_array.push(pre_sort);
                                //     }
                                // }).catch((err) => {})
                                // sorted_cart_array.push(pre_sort);
                            }).catch((err) => {})
                        )
                        
                    }

                    if(i == 3){
                        // check pay on delivery
                        promises.push(
                            service.checkBusinessPayOnDelivery(this, element[0].product_business).then(response => {
                                if(response.body.status == 200) {
                                    pre_sort[3] = response.body.data;
                                    // sorted_cart_array.push(pre_sort);
                                }
                            }).catch((err) => {})
                        )
                    }
                }
               
                //process all promises
                Promise.all(promises)
                .then(() => { 
                // for(i=0;i<promises.length;i++){
                    // sorted_cart_array.push(pre_sort);

                    //----//ups--filter-for-buy-now///
                    if(this.buy_now_order && (buy_now_count == 0)){
                        //--get localstorage buy-now-ref
                        let buy_now_ref = localStorage.getItem('bnrf');
                        let itm_count = 0;
                        //console.log('999kkkhug---'+buy_now_ref);
                        element.forEach(function(item){
                            if(item.active_order){
                                if(item.product_buy_now_ref && (item.product_buy_now_ref == buy_now_ref)){ //more auth
                                    //show only this item in this group_items only
                                    pre_sort[1][itm_count].can_show = true;
                                    //pick this group
                                    buy_now_count++;
                                }else{
                                    pre_sort[1][itm_count].can_show = false; //assign not active n not current buy now as false
                                }
                            }else{
                                pre_sort[1][itm_count].can_show = false; //assign not active buy now as false
                            }
                            itm_count++;
                        }, this);
                        //allow push here
                        if(buy_now_count == 1){  //for the very first active ones
                            sorted_cart_array.push(pre_sort);
                        }
                    }
                    //----../--//ups--filter-for-buy-now///
                    else{
                        sorted_cart_array.push(pre_sort);  
                    }
                    // 
                // }
                })
                .catch((e) => {
                    // handle errors here
                });
                //..promises hub

                //--increment
                pre_sort_index++;
                //--increment

            }, this);
           
            
            this.sorted_cart = sorted_cart_array;

            //----//ups--filter-for-buy-now///
            // if(this.buy_now_order){
            //     let buy_now_group_index = 0; //ini
            //     //--get localstorage buy-now-ref
            //     let buy_now_ref = localStorage.getItem('bnrf');
            //     //get last entry...[length - 1]
            //     let grp_count = 0; let itm_count = 0;
            //     console.log('999kkkhug---'+buy_now_ref);
            //     this.sorted_cart.forEach(function(group) {console.log('99-0');
            //     //for(let group of this.sorted_cart){console.log('99-0');
            //         for(let item of group[1]){console.log('99-01');
            //             if(item.active_order){console.log('99-02');
            //                 if(item.product_buy_now_ref && (item.product_buy_now_ref == buy_now_ref)){ //more auth
            //                     //show only this item in this group_items only
            //                     sorted_cart_array[grp_count][1][itm_count].can_show = true;
            //                     //pick this group
            //                     buy_now_group_index = grp_count;
            //                 }
            //             }
            //             itm_count++;
            //         }
            //         grp_count++;
            //     }, this);
            //     //assign as
            //     this.sorted_cart =  sorted_cart_array[buy_now_group_index];
            // }
            //----../--//ups--filter-for-buy-now///

            this.loading = false;

            return this.sorted_cart
           // return []
        },
       

        preset(){
            this.loading = true;
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.loggedIn = true;
                    self.loading = false;
                }else {
                    // self.$router.push('login');
                }
                self.prepCart();
            });
        },

        //verify coupon code for manul entries
        verifyCouponEntry(group_index){
            this.coupon_entry_error = ""; //reset
            let coupon_index = 0;
            let coupon_match = 0;
            for(let coupon of this.sorted_cart[group_index][4]){
                if(coupon.discount_is_private == 1){
                    if(coupon.discount_coupon_code == this.coupon_entry){
                        this.sorted_cart[group_index][4][coupon_index].discount_validated = 1;
                        this.couponsComponentKey++;
                        coupon_match++;
                    }
                }
                coupon_index++;
            }
            if(coupon_match == 0){
                this.coupon_entry_error = "sorry, not verified";
            }
            this.coupon_entry = ''; //reset
        },

        //check if coupons can be used on orderd items
        canUseCoupon(coupon){
            if((coupon.discount_type == 4) || (coupon.discount_type == 5)){
                if((coupon.discount_type == 4)){ //product coupon
                    let sorted = this.checked_out.filter(function(item){ return item.product_main_id==coupon.discount_product;});
                    if(sorted.length != 0){
                        return true;
                    }
                }
                if((coupon.discount_type == 5)){ //product item coupon
                    let sorted = this.checked_out.filter(function(item){ return item.product_item_id==coupon.discount_product_item;});
                    if(sorted.length != 0){
                        return true;
                    }
                }
            }else{
                return true;
            }
        },

        //add or remove selected coupons
        set_coupons(i,i2,coupon,coupon_percentage){
            let calc = 0;
            let calc_by_qty = 0; //mostly for product coupon effect only
            if(this.sorted_cart[i].total_order_amt != 0){ //check if a product from this group had been added to checkout 
                /////////-----
                //first check if coupon is in the array of selected coupons
                if(!coupon.added){ //not selected
                // if((found_sellpoint_coupon.length == 0) || (found_product_item_coupon.length == 0)){ //not selected
                    //update if a coupon affected item 
                    if((coupon.discount_type == 4) || (coupon.discount_type == 5)){//ie product coupon
                        //first check if coupon effect is quantity affected and then continue with calculations
                        if(Number(this.sorted_cart[i][1][i2].product_item_order_quantity) >= coupon['discount_min_quantity']){
                            //calc the percentage value with sellpoint current order amount
                            calc = ((coupon_percentage / 100) * this.sorted_cart[i][1][i2].actual_product_item_price); //the item
                            calc_by_qty = (calc * this.sorted_cart[i][1][i2].product_item_order_quantity); //add qty effect
                            this.sorted_cart[i][1][i2].item_order_coupons_discounts.push(coupon);
                            this.sorted_cart[i][1][i2].total_item_order_coupons_amount += calc; //add to total order coupons
                            // remove from product item current order amount
                            this.sorted_cart[i][1][i2].product_item_price -= calc;

                            // remove from sellpoint current order amount
                            this.sorted_cart[i].total_order_amt -= calc_by_qty
                            // remove from total current order price
                            this.total_order_amt -= calc_by_qty;
                            coupon.value = calc; //set coupon
                        }
                    }else{ //business coupon only
                        //first check if coupon effect is quantity affected and then continue with calculations
                        if(Number(this.sorted_cart[i].items_in_checkout) >= coupon['discount_min_quantity']){
                            //calc the percentage value with sellpoint current order amount
                            calc = ((coupon_percentage / 100) * this.sorted_cart[i].total_order_amt);
                    
                            this.sorted_cart[i].order_coupons_discounts.push(coupon);
                            this.sorted_cart[i].total_order_coupons_amount += calc; //add to total order coupons
            
                            // remove from sellpoint current order amount
                            this.sorted_cart[i].total_order_amt -= calc;
                            // remove from total current order price
                            this.total_order_amt -= calc;
                            coupon.value = calc; //set coupon
                        }
                    }
                    
                    // add to sellpoint used coupons
                    coupon.added = true; //set coupon
                    // coupon.value = calc; //set coupon
                    // // remove from total current order price
                    // this.total_order_amt -= calc;
                    
                }else{ //selected before
                    //get the coupon percentage value
                    calc = coupon.value;
                    //check if a coupon affected item //ie product coupon
                    if((coupon.discount_type == 4) || (coupon.discount_type == 5)){
                        calc_by_qty = (calc * this.sorted_cart[i][1][i2].product_item_order_quantity); //add qty effect
                        //first check if coupon effect is quantity affected and then continue with calculations
                        if(Number(this.sorted_cart[i][1][i2].product_item_order_quantity) >= coupon['discount_min_quantity']){
                            const index = this.sorted_cart[i][1][i2].item_order_coupons_discounts.findIndex(c => c.discount_id === coupon.discount_id) //best removal
                            this.sorted_cart[i][1][i2].item_order_coupons_discounts.splice(index, 1);
                            this.sorted_cart[i][1][i2].total_item_order_coupons_amount -= calc; //remove from total order coupons

                            // add to item current order amount
                            this.sorted_cart[i][1][i2].product_item_price += calc;

                            // add to sellpoint current order amount
                            this.sorted_cart[i].total_order_amt += calc_by_qty;
                            // add to total current order price
                            this.total_order_amt += calc_by_qty;
                        }
                    }else{ //business coupon only
                        //first check if coupon effect is quantity affected for no(qty) of group items ordered and then continue with calculations
                        if(Number(this.sorted_cart[i].items_in_checkout) >= coupon['discount_min_quantity']){
                            const index = this.sorted_cart[i].order_coupons_discounts.findIndex(c => c.discount_id === coupon.discount_id) //best removal
                            this.sorted_cart[i].order_coupons_discounts.splice(index, 1);
                            this.sorted_cart[i].total_order_coupons_amount -= calc; //remove from total order coupons
                            
                            // add to sellpoint current order amount
                            this.sorted_cart[i].total_order_amt += calc;
                            // add to total current order price
                            this.total_order_amt += calc;
                        }
                    }
                   
                    // remove to sellpoint used coupons
                    coupon.added = false; //set coupon
                    
                    // // add to total current order price
                    // this.total_order_amt += calc;
                    coupon.value = 0; //reset coupon percentage value
                }
            }else{
                // toastr.warning("Select an Order", 'Warning!');
                this.coupon_code.checked = false;
            }
            this.forceRerender();
        },

        getDeliveryLocations(i,delivery_selected_state){
            this.activate_processing();
            if(delivery_selected_state != undefined){
                let sorted_options = [];
                this.sorted_cart[i].selected_business_delivery_option = false;//reload
                //loop through groupd delivery options and match states
                for(let option of this.sorted_cart[i][2]){
                    if(option.business_delivery_state_id == delivery_selected_state.state_id){
                        sorted_options.push(option);
                    }
                }
                this.sorted_cart[i].selected_delivery_state_locations = sorted_options;
                document.getElementById(i+"BDLS").style= "display:block;";
                this.componentDeliveryLocationsKey++;
            }
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state){
            this.activate_processing();
            if(state != undefined){
                // service.getCities(this,state).then(response => {
                service.getCities(this,state.state_id).then(response => {
                    if(response.body.status == 200) {
                        this.cities =  response.body.data;
                        this.deactivate_processing();
                    }
                }).catch((err) => {this.deactivate_processing()})
            }
        },

        setOrderLocations(location){
            if(location.city != undefined){
                //loop through orders
                let i = 0;
                for (let group of this.sorted_cart) { 
                    // i = this.sorted_cart.indexOf(group);
                    if((group[2]) &&(group[2].length != 0)){//if has business delivery location
                        //check for option match
                        for (let option of group[2]) { 
                            if(option.business_delivery_state_id == location.state.state_id){
                                // console.log("option.business_delivery_city="+option.business_delivery_city)
                                // console.log("location.city.city_id="+location.city.city_id)
                                // console.log("option.business_delivery_other_option="+option.business_delivery_other_option)
                                // console.log("location.city.city_name="+location.city.city_name);
                                // console.log("option.business_delivery_city="+option.business_delivery_city)
                                if((option.business_delivery_city == location.city.city_id) || (option.business_delivery_other_option == location.city.city_name) || ((option.business_delivery_city == 0) && (option.business_delivery_other_option == 'nill'))){
                                //    console.log("go22")
                                    this.calc_sellpoint_delivery_fee(i,option);//assign option match
                                }
                            }
                        }
                    }else{//no delivery option assigned
                        //assign location options ../but with no charge
                        this.sorted_cart[i].delivery_general_set_option = location;
                    }
                    i++;
                }
            }
        },

        //for type of product(P) or sellpoint(SP)
        calc_product_delivery_fee(i,option,product_index){
           //first check if this product's delivery option has been added
            if(this.sorted_cart[i][1][product_index].delivery_option_fee != undefined){
                if(this.sorted_cart[i][1][product_index].delivery_option_fee != 0.0){
                    this.total_delivery_fee -= this.sorted_cart[i][1][product_index].delivery_option_fee
                    this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i][1][product_index].delivery_option_fee;
                }
            }

            this.sorted_cart[i][1][product_index].selected_product_delivery_option = option;//for display

            this.sorted_cart[i][1][product_index].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i][1][product_index].delivery_option_fee = Number(option.business_delivery_option_price);
            
            //update delivery fees with new one
            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            this.total_delivery_fee += Number(option.business_delivery_option_price)
        },

        //sellpoint
        calc_sellpoint_delivery_fee_XXX(i,option){
            //first check if already calculated delivery fee and deduct
            if(this.sorted_cart[i].delivery_option_fee != 0.0){
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }
           
            this.sorted_cart[i].selected_business_delivery_option = option; //for display

            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;
            this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            //cos product delivery may occur
            this.sorted_cart[i].total_delivery_charge += Number(option.business_delivery_option_price);
            //update delivery fee with new one
            this.total_delivery_fee += Number(option.business_delivery_option_price);

           
        },

        //NEW with independent delivery_option product delivery fee calculations and CONSTRAINTS inclusions
        calc_sellpoint_delivery_fee(i,option){
           
            //first check if already calculated delivery fee and deduct
            if(this.sorted_cart[i].delivery_option_fee != 0.0){
                this.total_delivery_fee -= this.sorted_cart[i].delivery_option_fee
                this.sorted_cart[i].total_delivery_charge -= this.sorted_cart[i].delivery_option_fee;
            }
            
            //display
            this.sorted_cart[i].selected_business_delivery_option = option; //for display
            //assign
            this.sorted_cart[i].delivery_option = option.business_delivery_option_id;

            //calculate

            //....b4.... this.sorted_cart[i].delivery_option_fee = Number(option.business_delivery_option_price);

            //...new--now
            this.sorted_cart[i].delivery_option_total_delivery_fee = 0;
            
            

            //check: if option does not have product delivery fees set
            let fees =  option.business_products_delivery_fees;
            if(fees.length == 0){
                //calculate delivery with Business Constraints
                if(this.sorted_cart[i].business_shipping_calculation_method == 9){ //one charge for all items ordered in this business
                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                }else{
                    //constraints would affect/charge each item in this business
                    // filter get items of this business sorted cart that has been selected for checkout
                    let items_to_checkout = this.sorted_cart[i][1].filter(function(item){ return item.product_checked==true;});
                    for (let item of items_to_checkout) { 
                        if(this.sorted_cart[i].business_shipping_calculation_method == 10){ //charge each item
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                        }
                        if(this.sorted_cart[i].business_shipping_calculation_method == 11){ //charge each item and the quantities
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price)
                        }
                    }
                }
            }else{
                //option has product delivery fees set
                //so
                // filter get items of this business sorted cart that has been selected for checkout
                let items_to_checkout = this.sorted_cart[i][1].filter(function(item){ return item.product_checked==true;});

                //calculate for each item that has set delivery fee
                for (let item of items_to_checkout) { 
                    //some resets ... in situations wherby has been set by previous delivery options
                    if(item.has_calculated_product_delivery_fee == true)
                    {
                        item.product_delivery_fee = 0;
                        item.has_calculated_product_delivery_fee = false;
                        item.calculated_product_delivery_fee = 0
                    };
                    //some resets../
                    //loop in fees
                    for (let fee of fees) { 
                        item.product_delivery_fee = Number(fee.product_delivery_fee);
                        if(item.product_main_id == fee.product_delivery_product){ //product has shipping fee
                           //check product delivery fee calculation constraints
                           if(item.product_shipping_calculation_method == 13){ //shipping fee charges all product quantity ordered
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * fee.product_delivery_fee)
                            item.calculated_product_delivery_fee = Number(item.product_item_order_quantity * fee.product_delivery_fee);
                           }
                           if(item.product_shipping_calculation_method == 12){ //shipping fee does not charge product quantity ordered 
                            this.sorted_cart[i].delivery_option_total_delivery_fee += Number(fee.product_delivery_fee);
                            item.calculated_product_delivery_fee = Number(fee.product_delivery_fee);
                           }
                           //mark as calculated
                           item.has_calculated_product_delivery_fee = true;
                           
                        }
                    }
                   
                }
                //restock sorted items
                // this.sorted_cart[i][1] = items;
                //.../..calculate for each item that has set delivery fee

                //then calculate for general sellpoint delivery option

                //check: if no of items with calculated product delivery fee for this option is == to the total no of items in this business cart
                let sorted_fees = items_to_checkout.filter(function(item){ return item.has_calculated_product_delivery_fee==true;});
                //if less than, more calculations to be made
                if(sorted_fees.length < items_to_checkout.length){ //more calculations to be made
                    //calculate delivery with Business Constraints
                    if(this.sorted_cart[i].business_shipping_calculation_method == 9){ //one charge for all items ordered in this business
                        this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                    }else{
                        //constraints would affect/charge each item in this business
                        for (let item of items_to_checkout) { 
                            if(!item.has_calculated_product_delivery_fee){ //if has not been calculated
                                if(this.sorted_cart[i].business_shipping_calculation_method == 10){ //charge each item
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(option.business_delivery_option_price)
                                }
                                if(this.sorted_cart[i].business_shipping_calculation_method == 11){ //charge each item and the quantities
                                    this.sorted_cart[i].delivery_option_total_delivery_fee += Number(item.product_item_order_quantity * option.business_delivery_option_price)
                                }
                            }
                        }
                    }
                }
                //end more calculations
            }
            

            //totalling
            this.sorted_cart[i].delivery_option_fee = (Number(this.sorted_cart[i].delivery_option_total_delivery_fee));
            //cos product delivery may occur
            this.sorted_cart[i].total_delivery_charge += (Number(this.sorted_cart[i].delivery_option_total_delivery_fee));
            //update delivery fee with new one
            this.total_delivery_fee += (Number(this.sorted_cart[i].delivery_option_total_delivery_fee));
            //..totalling

            //../calculate

            //rerender
            this.forceRerender();
        },

        setPaymentOption(i,option){
            this.sorted_cart[i].payment_mode = option;
        },
    
        ///--=
        pre_checkout(){
            //check login
            this.preset();
        },

        addRefreshCheckout(it,group_index,item_index){
            it.product_item_order_quantity++;
            this.refreshCheckout(it,group_index,item_index);
        },

        removeRefreshCheckout(it,group_index,item_index){
            if(it.product_item_order_quantity > 1){
                it.product_item_order_quantity--;
                this.refreshCheckout(it,group_index,item_index);
            }
        },

        //when quantity is increased or reduced
        refreshCheckout(it,group_index,item_index){
            //new.2.
            this.checkWholesalePrices(it,group_index,item_index);
            //new..//check for discount afected by quantity
            this.checkDiscountsByQuantity(group_index,item_index,it.product_item_quantity,it.product_item_order_quantity);
            //./new..//

            // if(it.product_item_order_quantity > 1){
            if(it.product_item_order_quantity >= 1){
                //first check pass
                if(this.checkOrderQuantity(group_index,item_index,it.product_item_quantity,it.product_item_order_quantity)){
                    //then recalculate total orders
                    this.sorted_cart[group_index].total_order_amt = 0.0;
                    this.total_order_amt = 0.0;
                    this.checked_out.forEach(function(item) { 
                        this.sorted_cart[group_index].total_order_amt += (item.product_item_order_quantity * item.product_item_price);
                        //calculate general total order amount
                        this.total_order_amt += (item.product_item_order_quantity * item.product_item_price);
                    }, this);

                    //then recalculate coupons ///..new..//for items in groups
                    if(this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.length > 0){
                        this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.forEach(function(coupon) { 
                        
                            //reset this coupon former activities
                            coupon.added = false; //set coupon
                            const index = this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.findIndex(c => c.discount_id === coupon.discount_id) //best removal
                            this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.splice(index, 1);
            
                            //then re-add
                            this.set_coupons(group_index,item_index,coupon,coupon.discount_percentage);
                        }, this);
                    }

                    //then recalculate coupons ///..for groups only
                    if(this.sorted_cart[group_index].order_coupons_discounts.length > 0){
                        this.sorted_cart[group_index].order_coupons_discounts.forEach(function(coupon) { 
                        
                            //reset this coupon former activities
                            coupon.added = false; //set coupon
                            const index = this.sorted_cart[group_index].order_coupons_discounts.findIndex(c => c.discount_id === coupon.discount_id) //best removal
                            this.sorted_cart[group_index].order_coupons_discounts.splice(index, 1);
                            this.sorted_cart[group_index].total_order_coupons_amount -= coupon.value; //remove from total order coupons
            
                            //then re-add
                            this.set_coupons(group_index,item_index,coupon,coupon.discount_percentage);
                        }, this);
                    }
                    
                    //then recalculate shipping fee
                    if((this.sorted_cart[group_index].selected_business_delivery_option)){
                        this.calc_sellpoint_delivery_fee(group_index,this.sorted_cart[group_index].selected_business_delivery_option);
                    }
                    
                }

                this.forceRerender();
            }
        },
        
        addToCheckout(item,group_index,item_index){
            //some settings
            if(item.product_item_order_quantity == 0){
                item.product_item_order_quantity = 1;
            }

            this.sorted_cart[group_index][1][item_index].can_remove = false; //disable remove item
            this.sorted_cart[group_index].products_in_checkout = true; //for this group checkout

            //for product delivery checks
            if(this.sorted_cart[group_index][1][item_index].has_delivery){
                this.sorted_cart[group_index].products_with_delivery_details_checked.push(item);
            }else{
                this.sorted_cart[group_index].products_without_delivery_details_checked.push(item);
            }

            //for does not need delivery checks
            ///--check first
            if(this.sorted_cart[group_index].show_delivery_option == 0){ //do not overide when it is already set to 1 //to avoid a stop to shipping when there is a product order together with a service order
                if(item.product_item_need_shipping == 0){
                    this.sorted_cart[group_index].show_delivery_option = 0;
                    this.sorted_cart[group_index].delivery_option = "Free Delivery"; //set/reset FLAG DOWN Delivery
                }else{
                    this.sorted_cart[group_index].show_delivery_option = 1;
                }
            }

            this.checked_out.push(item);
            this.sorted_cart[group_index][1][item_index].product_checked = true; //[1] means the position of the items in a sellpoint as added in sorted_cart
            //caculate group store total order amount
            this.sorted_cart[group_index].total_order_amt += (item.product_item_order_quantity * item.product_item_price);
            //calculate general total order amount
            this.total_order_amt += (item.product_item_order_quantity * item.product_item_price);
            this.sorted_cart[group_index].items_in_checkout++;

            //some settings
            if(this.sorted_cart[group_index][1][item_index].has_delivery){
                this.sorted_cart[group_index][1][item_index].display_delivery_details = true; //show delivery details set for this item
            }

            //new ... recalculate sellpoint shipping fee if already selected
            if(this.sorted_cart[group_index].selected_business_delivery_option){
                this.calc_sellpoint_delivery_fee(group_index,this.sorted_cart[group_index].selected_business_delivery_option);
            }

            
            ///...for displaying totals and delivery options for buy_now_order
            if(this.buy_now_order){
                document.getElementById(item.item_index+"PRT_CART").style= "display:block;";
            }
        },
        
        removeFromCheckout(item,group_index,item_index){
            const index = this.checked_out.findIndex(p => p._id === item._id) //best removal
            this.checked_out.splice(index, 1);
            this.sorted_cart[group_index][1][item_index].product_checked = false;
            
            //for product or product items coupons check
            //remove all coupon effect
            if((this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts) && (this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.length > 0)){
                this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.forEach(function(coupon) {
                    const index = this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.findIndex(c => c.discount_id === coupon.discount_id) //best removal
                    this.sorted_cart[group_index][1][item_index].item_order_coupons_discounts.splice(index, 1);
                    this.sorted_cart[group_index][1][item_index].total_item_order_coupons_amount -= coupon.value; //remove from total order coupons
                
                    //....////
                    coupon.added = false; //unset ..//redo and redo 2lines below
                    // add back coupon effect to product item current order amount
                    this.sorted_cart[group_index][1][item_index].product_item_price += coupon.value;
                    // add back coupon effect to sellpoint current order amount
                    this.sorted_cart[group_index].total_order_amt += coupon.value;
                }, this);
            }

            //for product delivery checks
            if(this.sorted_cart[group_index][1][item_index].has_delivery){
                const index = this.sorted_cart[group_index].products_with_delivery_details_checked.findIndex(p => p._id === item._id)
                this.sorted_cart[group_index].products_with_delivery_details_checked.splice(index, 1);;
            }else{
                const index =this.sorted_cart[group_index].products_without_delivery_details_checked.findIndex(p => p._id === item._id)
                this.sorted_cart[group_index].products_without_delivery_details_checked.splice(index, 1);;
            }

            //deduct group store total order amount
            this.sorted_cart[group_index].total_order_amt -= (item.product_item_order_quantity * item.product_item_price);
            //deduct general total order amount
            this.total_order_amt -= (item.product_item_order_quantity * item.product_item_price);
            this.sorted_cart[group_index].items_in_checkout--; //deduct

            this.sorted_cart[group_index][1][item_index].can_remove = true; //enable remove item

            //some checkings to make sure shipping fee is reset when products are unchecked
            //and no products selected
            if((this.sorted_cart[group_index].items_in_checkout == 0) && (this.sorted_cart[group_index].delivery_option != "Free Delivery")){
                this.total_delivery_fee -= this.sorted_cart[group_index].delivery_option_fee; //reset
                this.sorted_cart[group_index].delivery_option_fee = 0; //reset
                this.sorted_cart[group_index].delivery_option = 0; //very funny - hard reset, cos some delivery option are strings eg. "Free delivery"
                this.sorted_cart[group_index].total_delivery_charge = 0; //reset
            }

            //new ... recalculate sellpoint shipping fee if already selected
            if(this.sorted_cart[group_index].selected_business_delivery_option){
                this.calc_sellpoint_delivery_fee(group_index,this.sorted_cart[group_index].selected_business_delivery_option);
            }
            
        },

        checkWholesalePrices(item,group_index,item_index){
            if((Object.keys(item.product_item_moqs).length !== 0)){
                //refresh
                if(item.product_item_actual_mapped_price != 0){
                    this.sorted_cart[group_index][1][item_index].product_item_price = item.product_item_actual_mapped_price;
                }
                //loop through this product item moqs
                let checked_moqs = []; //for picking checked array 
                for(let moq of item.product_item_moqs) {
                    //if quantity matches with the moq
                    if(!(checked_moqs.includes(moq.product_item_moq_id))){
                        if(Number(Number(this.sorted_cart[group_index][1][item_index].product_item_order_quantity) >= moq.product_item_moq)){
                            //assign the matching price
                            this.sorted_cart[group_index][1][item_index].product_item_price = moq.product_item_moq_price;
                            this.sorted_cart[group_index][1][item_index].product_item_price_f = this.numFormat(this.sorted_cart[group_index][1][item_index].product_item_price);
                        }
                    }
                    checked_moqs.push(moq.product_item_moq_id);
                }
            }
        },


        process_checkout(group){
            if(this.checked_out.length > 0){
                let processed_checkout = {};
                // if((group.delivery_option != 0) && (group.delivery_option != undefined)){
                processed_checkout.order_user_id = this.user.user_id || 0;
                // processed_checkout.order_mode = 1; //loggedIn
                processed_checkout.order_business = group[0];
                //new//if//agentco//orders
                if(group.is_from_agent == 1){
                    processed_checkout.order_is_from_agent = group.is_from_agent;
                    processed_checkout.order_business_agent = group.business_agent_username;
                }
                //.//if//agentco//orders
                //part-payments-checks
                if((this.part_payments_request_option) || (group.part_payments_request == 1)){
                    processed_checkout.order_part_payments_request = 1;
                }
                //..//part-payments-checks
                let order_url = group[0] + (new Date().getTime()); //set order url
                processed_checkout.order_url = order_url,
                processed_checkout.order_total_amount = group.total_order_amt;
                processed_checkout.order_delivery_option = group.delivery_option;
                processed_checkout.order_total_delivery_charge = group.total_delivery_charge;
                processed_checkout.order_payment_mode = group.payment_mode || 1; //default -pay now
                processed_checkout.order_coupons_discounts = group.order_coupons_discounts;
                processed_checkout.total_order_coupons_amount = group.total_order_coupons_amount;
                processed_checkout.order_share_cart = 0;
                if(this.share_cart_option){
                    processed_checkout.order_share_cart = 1;
                }
                processed_checkout.order_items = [];
                this.checked_out.forEach(function(element) { //groups
                    if(element.product_business == group[0]){//product_business
                        processed_checkout.order_items.push(element);
                    }
                    processed_checkout.status = "processed";
                }, this);
                if(processed_checkout.status == "processed"){
                    ///UPDATE -- process to save in localforage
                    if(this.loggedIn){
                        processed_checkout.order_mode = 1; //loggedIn
                        service.checkout(this,processed_checkout).then(function(data) {
                            if(data.body.status == 201) {
                                this.process_count++;
                                //remove from sorted cart and cart
                                processed_checkout.order_items.forEach(function(item) {
                                    this.$store.commit(REMOVE_FROM_CART, item._id); //remove from cart
                                    const index = this.checked_out.findIndex(p => p._id === item._id) //best removal
                                    this.checked_out.splice(index, 1);
                                    //remove from checkout, later find group id and remove from sorted cart
                                    // const index = this.sorted_cart[group_index][1].findIndex(p => p._id === item._id) //best removal
                                    // this.sorted_cart[group_index][1].splice(index, 1);
                                }, this);
                            // console.log(this.process_count)
                            }
                            // if(this.process_count == this.sorted_cart.length){
                            if(this.process_count == this.processed_groups){
                                this.total_delivery_fee = 0;
                                this.total_order_amt = 0;
                                //move to checkout page with particular order url
                                // location.replace("/checkout/"+order_url)
                                this.data_processing_message = 'Processing......';
                                // console.log("here4444")
                                // console.log(processed_checkout)
                                location.replace("/checkout/"); //just move to checkout and fetch checkout orders there
                            }
                        }).catch((err) => {
                            if(err) {
                                // toastr.warning("Something went wrong", 'Warning!'); 
                            // console.log(err) //possibly a load payment error
                            } 
                        })
                    }else{
                        processed_checkout.order_mode = 0; //not loggedIn
                        //return to be saved in localforage
                        this.process_count++;
                        //remove from sorted cart and cart
                        processed_checkout.order_items.forEach(function(item) {
                            this.$store.commit(REMOVE_FROM_CART, item._id); //remove from cart
                            const index = this.checked_out.findIndex(p => p._id === item._id) //best removal
                            this.checked_out.splice(index, 1);
                        }, this);
                        
                        // if(this.process_count == this.sorted_cart.length){
                        if(this.process_count == this.processed_groups){
                            this.total_delivery_fee = 0;
                            this.total_order_amt = 0;
                            // //return to be saved for checkout in localforage
                            // return processed_checkout;
                        }
                        //return to be saved for checkout in localforage
                        return processed_checkout;
                    }
                    ///...///UPDATE -- process to save in localforage
                }
            }
        },

        //share_cart
        share_cart(){
            this.share_cart_option = true;
            if(this.share_cart_option){
                this.process_orders();
            }
        },
        
        process_orders(){
            this.data_processing_message = ''; //reset
            this.disable_btn_01 = true;
            if(this.checked_out.length == 0){
                this.data_processing_message = 'Select Items to process';
                // toastr.warning("elect Items to process", 'Warning!'); 
            }else{
                
                let processed = [];
                let process_errors = 0;
                let process_error_list = [];

                //prepare and validate process checkout
                this.checked_out.forEach(function(item) {
                    //check for order quantity
                    if(Number(item.product_item_order_quantity) > item.product_item_quantity){
                        let err = "The quantity you entered for "+item.product_name+" is above Item Quantity";
                        process_errors++;
                        process_error_list.push(err);
                    }
                    //check for order quantity

                    //check for xxc
                }, this);

            
                this.sorted_cart.forEach(function(group) {
                    if(group.items_in_checkout){ //check if has items in cart
                        if(group[2] && (group[2].length > 0)){
                            if((group.delivery_option != 0) && (group.delivery_option != undefined)){
                                //check group delivery option is selected
                                processed.push(group);
                            }else{
                                let err = "";
                                if(this.buy_now_order){
                                    err = "Please select a delivery option";
                                }else{
                                    err = "Please select a delivery option for "+group.business_name 
                                }
                                process_errors++;
                                process_error_list.push(err);
                            }
                        }else{
                            //free delivery //push
                            group.delivery_option = "Free Delivery"; //recheck
                            processed.push(group);
                        }
                    }
                }, this);
                
                
                //Check and output errors
                if(process_errors > 0){
                    process_error_list.forEach(function(error) {
                        // toastr.error("error ", 'Warning!');
                        this.data_processing_message =  this.data_processing_message + " . " +error;
                        this.disable_btn_01 = false;
                    }, this);
                }else{
                    ///UPDATE -- Don't process checkout except if user is logged instead save in localforage
                    if(this.loggedIn){
                        if((processed.length != 0) && (process_errors == 0)){
                            this.processed_groups = processed.length;
                            processed.forEach(function(group) {
                                this.process_checkout(group);
                            }, this);
                        }
                    }else{
                        //save the whole processed in in local forage
                        //localforage.setItem('buy_now_order', processed).then(function (value) { }).catch(function(err) {});
                        //process and save
                        let processed_to_store_in_forage = [];
                        if((processed.length != 0) && (process_errors == 0)){
                            this.processed_groups = processed.length;
                            processed.forEach(function(group) {
                                processed_to_store_in_forage.push(this.process_checkout(group));
                            }, this);
                            localforage.setItem('not_loggedin_processed_orders', processed_to_store_in_forage).then(function (value) { }).catch(function(err) {});
                        }
                        //then push to checkout
                        this.data_processing_message = 'Processing Orders......';
                       this.$router.push("checkout");
                    }
                }
            }
            
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state){
            this.activate_processing();
            if(state != undefined){
                // service.getCities(this,state).then(response => {
                service.getCities(this,state.state_id).then(response => {
                    if(response.body.status == 200) {
                        this.cities =  response.body.data;
                        this.deactivate_processing();
                    }
                }).catch((err) => {this.deactivate_processing()})
            }
        },


  },
  created(){
    if(this.$route.path == '/order'){
        this.buy_now_order = true;
    }
    document.title = "Cart" + " | "+service.app_name;
    this.preset();
   
    this.getStates();
    // this.prepCart();
  }
     
}


// WEBPACK FOOTER //
// ./src/pages/Orderpoint/CartWidget/script.js